import { render } from "./TouchWithUs.vue?vue&type=template&id=64a1b54f"
import script from "./TouchWithUs.vue?vue&type=script&lang=js"
export * from "./TouchWithUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__